import { h, Fragment } from "preact";
import { Button, Input, Typography, Skeleton } from "antd";
import useProfile from "./useProfile";
import { DeleteOutlined, EditFilled, SaveFilled} from '@ant-design/icons';
import { useEffect, useState } from "preact/hooks";

export default function ProfileInfoTab() {
    const {person, profile, isLoading, options, personKeycloak, updateUser, teammates} = useProfile();
    const name = person?.firstName && person?.lastName ? person.firstName +  " " + person.lastName : " ";
    const email = person?.email;
    const position = person?.attributes?.position ? person.attributes.position[0] : " ";
    let userRole = null;
    for (const role of personKeycloak.realmAccess.roles) {
        if (options.some((option) => option.value === role)) {
            userRole = role;
            break;
        }
    }

    const [isEdit, setIsEdit] = useState(false);
    const [inputName, setInputName] = useState(name);
    
    useEffect(()=>{
        setInputName(person?.firstName && person?.lastName ? person.firstName +  " " + person.lastName : " ")
    }, [person]);

    const formFields = [
        {label: 'Name', value: name, editable: true},
        {label: 'Position', value: position, editable: false},
        {label: 'Role', value: userRole, editable: false},
        {label: 'Company Name', value: profile?.company, editable: false},
        {label: 'E-Mail', value: email, editable: false},
        {label: 'Phone Number', value: 'no phone', editable: false},
        {label: 'Timezone', value: "Asia/Almaty (UTC+05:00)", editable: false},
    ];

    //TODO: edit handleEditClick, since window.location.reload() is not a best practice, but i dont understand why after updating only the name, person is not updated

    const handleEditClick = () => {
        if(isEdit){
            updateUser(person.id, inputName).then(()=>{
                window.location.reload();
            })
        }
        setIsEdit(!isEdit);
      };

    const handleChange = (event) => {
        setInputName(event.target.value);
      };

    const getForm = ()=>{
        return formFields.map((field) =>{
            return <tr>
                <td style={{
                    fontWeight: '600',
                }}>{field.label}:</td>
                <td 
                width={"75%"}
                >
                    <div>
                    <Input 
                    className={field.label}
                    style={{flex: '1'}} 
                    onChange={handleChange}
                   value={field.label === 'Name' ? inputName : field.value} 
                   readOnly={field.label === 'Name' ? !isEdit : true}
                   disabled={!field.editable} />
                {field.editable && 
                <Button onClick={handleEditClick} style={{
                    marginLeft: '-50px',
                    border: '0',
                    height: '20px',
                    WebkitAppearance: "none",
                 }}>{!isEdit ? <EditFilled/> : <SaveFilled/> }</Button>}
                 </div>
                </td>
            </tr>
        })
    }
    return (
        <>
            <Typography.Title level={3} style={{ marginBottom: "24px" }}>
                My Profile
            </Typography.Title>
            <Skeleton loading={isLoading}>
            <table style={{
                borderCollapse: 'separate',
                borderSpacing: '25px 10px'
            }}>{getForm()}</table>
            </Skeleton>
        </>
    )
}